import { Component, effect, input, OnDestroy, OnInit, output, Self, signal } from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import { ReplaySubject, Subscription } from 'rxjs';

@Component({
  selector: 'eiq-textarea',
  templateUrl: 'textarea.component.html',
  styleUrls: ['textarea.component.scss']
})
export class TextareaComponent implements OnInit, OnDestroy, ControlValueAccessor {
  hint = input<string>();
  label = input<string>();
  max = input<number>();
  maxRows = input<number>(10);
  min = input<number>();
  minRows = input<number>(2);
  placeholder = input<string>();
  required = input<boolean>(false);
  rows = input<number>();
  showError = input<boolean>(true);
  testId = input<string>();

  keyupEnter = output<void>();

  onChange: (value: string) => void;
  onTouched: () => void;

  control: FormControl;
  currentValue: string;
  resize$ = signal(true);

  private input$ = new ReplaySubject(1);
  private subscriptions: Subscription[] = [];

  constructor(@Self() public ngControl: NgControl) {
    this.ngControl.valueAccessor = this;
    effect(
      () => {
        if (this.rows()) {
          console.warn('TextareaComponent: "rows" input is set, disabling resize.');
          this.resize$.set(false);
        }
      },
      { allowSignalWrites: true }
    );
  }

  ngOnInit(): void {
    this.control = this.ngControl.control as FormControl;
    this.subscriptions.push(
      this.input$.subscribe((i: string) => {
        this.onTouched();
        this.onChange(i);
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(i: string): void {
    this.currentValue = i ?? '';
  }

  setValue($event: any): void {
    this.currentValue = $event.target.value;
    this.input$.next($event.target.value);
  }

  clearValue(): void {
    this.currentValue = '';
    this.input$.next('');
  }

  setDisabledState?(isDisabled: boolean): void {
    // Implement if needed
  }
}
